import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import SidebarMenu from '../components/SidebarMenu';
import ProfileDropdown from '../components/ProfileDropdown';
import ThemeToggle from '../components/ThemeToggle';
import './AdminLayout.css';

const getUser = () => {
  const u = localStorage.getItem('adminUser');
  return u ? JSON.parse(u) : null;
};

const AdminLayout = () => {
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    navigate('/admin/login', { replace: true });
  };

  const isSuperadmin = user?.role === 'superadmin';

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="brand">MANET Admin</div>
        <SidebarMenu />
        {isSuperadmin && (
          <div className="admin-sidebar-superadmin">
            <NavLink to="/admin/web-coordinators">Web Coordinators</NavLink>
            <NavLink to="/admin/login-logs">Login Logs</NavLink>
          </div>
        )}
      </aside>
      <div className="admin-main">
        <header className="admin-header">
          <div className="admin-header-left">
            <h2 className="admin-header-title">Admin Panel</h2>
          </div>
          <div className="admin-header-right">
            <ThemeToggle />
            <ProfileDropdown user={user} onLogout={handleLogout} />
          </div>
        </header>
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;


